import {
  postRegisterSelectOfferRequest,
} from '@/request/authApi/requests/apiRequests'
import {
  postRegisterSelectOfferConnectedRequest,
} from '@/request/globalApi/requests/registerRequests'

export default {
  namespaced: true,
  state: {
    paymentIntent: null,
  },
  getters: {
    getPaymentIntent(state) {
      return state.paymentIntent
    },
  },
  mutations: {
    SET_PAYMENT_INTENT(state, paymentIntent) {
      state.paymentIntent = paymentIntent
    },
  },
  actions: {
    updatePaymentIntent({ commit }, paymentIntent) {
      commit('SET_PAYMENT_INTENT', paymentIntent)
    },
    // MFC2-1631 — user CONNECTE : la requete passe par globalApi (Bearer) pour que l'API cree le
    // PaymentIntent sur SON customer Stripe, et paymentMethodId (optionnel) selectionne une methode
    // deja enregistree. Flux anonyme historique inchange (authApi, nouvelle methode).
    fetchPaymentIntent({ commit, rootState }, { token, offerId, paymentMethodId = null }) {
      const payload = paymentMethodId ? { offerId, paymentMethodId } : { offerId }
      const request = rootState.auth.isAuthorized
        ? postRegisterSelectOfferConnectedRequest(token, payload)
        : postRegisterSelectOfferRequest(token, payload)

      return new Promise((resolve, reject) => {
        request
          .then(response => {
            commit('SET_PAYMENT_INTENT', response.data.paymentIntent)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
